/** True when endpoint is a local Ollama server (API key optional). */
export function isOllamaEndpoint(endpointUrl: string): boolean {
  const url = (endpointUrl || "").toLowerCase();
  return url.includes("localhost:11434") || url.includes("127.0.0.1:11434");
}
